/**
 * Redirect Utilities
 *
 * Handles secure redirect functionality for authentication flows.
 * Provides utilities to safely redirect users back to their original location
 * after successful authentication, including cross-origin support.
 *
 * Features:
 * - URL validation against whitelist
 * - Query parameter handling
 * - Cross-origin redirect support
 * - Fallback URL handling
 * - Session storage backup
 *
 * This file serves as the main entry point and re-exports functionality
 * from specialized modules for backward compatibility.
 */

// Import all functions
import { getRedirectConfig } from "./redirect/redirectConfig.js";
import { isValidReturnUrl } from "./redirect/urlValidation.js";
import {
  getSafeRedirectUrl,
  storeReturnUrl,
  clearReturnUrl,
} from "./redirect/returnUrlHandlers.js";
import {
  createSignInUrl,
  redirectToSignIn,
} from "./redirect/signInRedirect.js";
import { performPostAuthRedirect } from "./redirect/postAuthRedirect.js";
import { EXTERNAL_SIGNIN_HELPER } from "./redirect/externalSignInHelper.js";

// Re-export all functions for named imports
export { getRedirectConfig } from "./redirect/redirectConfig.js";
export { isValidReturnUrl } from "./redirect/urlValidation.js";
export {
  getSafeRedirectUrl,
  storeReturnUrl,
  clearReturnUrl,
} from "./redirect/returnUrlHandlers.js";
export {
  createSignInUrl,
  redirectToSignIn,
} from "./redirect/signInRedirect.js";
export { performPostAuthRedirect } from "./redirect/postAuthRedirect.js";
export { EXTERNAL_SIGNIN_HELPER } from "./redirect/externalSignInHelper.js";

// Default export for backward compatibility
const redirectUtils = {
  getSafeRedirectUrl,
  storeReturnUrl,
  clearReturnUrl,
  createSignInUrl,
  redirectToSignIn,
  performPostAuthRedirect,
  isValidReturnUrl,
  getRedirectConfig,
  EXTERNAL_SIGNIN_HELPER,
};

export default redirectUtils;
